module.exports = __webpack_public_path__ + "img/user-for-openbadge-v3-1.c5dfd05b.png";